import { useAtomValue } from "jotai";
import { loadable } from "jotai/utils";

import { $documentLocalPath } from "../../internal/document-list";

/**
 * Hook to get the local file system path for a document.
 * @param documentId - The document ID
 * @returns The local path or undefined if not available
 */
export const useDocumentLocalPath = (documentId: string | undefined) => {
	const pathLoadable = useAtomValue(loadable($documentLocalPath(documentId ?? "")));

	return {
		path: pathLoadable.state === "hasData" ? pathLoadable.data : undefined,
		isLoading: pathLoadable.state === "loading",
		isError: pathLoadable.state === "hasError",
	};
};
